// ── 미팅지도 목록 글자 크기 (2026-09-11) ─────────────────────────────────────
//
//   요청: "켜면 항상 큰 상태를 유지하고, 끄면 원래대로."
//   계정에 기억한다(user_preferences) — 휴대폰에서 켜면 PC 에서도 그대로다.
//
//   ⚠ 서버 응답을 기다리면 작은 글자로 한 번 그려졌다가 커져서 깜빡인다.
//     useDarkMode.js:27 과 같은 방식으로 **localStorage 로 즉시 반영**하고 서버로 맞춘다.
//   저장 실패는 조용히 넘긴다 — 글자 크기 때문에 화면이 멈추면 안 된다
//     (useMeetingMapHandlers.js:77 의 기존 방식과 동일).
import { useCallback, useEffect, useState } from 'react';
import { apiClient } from '../../../api/apiClient';

const PREF_KEY = 'meeting_map_list_text_size';
const LS_KEY = 'meeting-map-list-text-size';
const VALID = ['normal', 'large'];

const normalize = (v) => (VALID.includes(v) ? v : 'normal');

export function useListTextSize() {
  const [textSize, setTextSize] = useState(() => {
    try { return normalize(localStorage.getItem(LS_KEY)); } catch (_) { return 'normal'; }
  });

  // 서버 값으로 맞춘다 (다른 기기에서 바꿨을 수 있다)
  useEffect(() => {
    let active = true;
    apiClient.get(`/api/my/preferences/${PREF_KEY}`)
      .then((res) => {
        if (!active || !res.ok) return;
        const next = normalize(res.data?.value);
        setTextSize(next);
        try { localStorage.setItem(LS_KEY, next); } catch (_) { /* 저장 실패는 무시 */ }
      })
      .catch(() => { /* 불러오기 실패는 치명적이지 않다 — 로컬 값으로 계속 */ });
    return () => { active = false; };
  }, []);

  const toggleTextSize = useCallback(() => {
    setTextSize((prev) => {
      const next = prev === 'large' ? 'normal' : 'large';
      try { localStorage.setItem(LS_KEY, next); } catch (_) { /* 무시 */ }
      apiClient.put(`/api/my/preferences/${PREF_KEY}`, { value: next })
        .catch(() => { /* 저장 실패는 무시 — 이 기기에서는 계속 적용된다 */ });
      return next;
    });
  }, []);

  return { textSize, toggleTextSize };
}
